<mat-tab-group dynamicHeight color="accent" (selectedTabChange)="selectedTabChange($event)">
  @for (tab of tabs; track tabTracker($index)) {
    <mat-tab [label]="tab.label">
      <tab [tab]="tab"></tab>
    </mat-tab>
  }
</mat-tab-group>
